if ( window.wp && window.wp.ajax ) {

    
    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        TextareaControl
    } = window.wp.components;

    const { 
        RawHTML 
    } = window.wp.element;

    registerBlockType('custom-gutenberg/card-banner', {
        // built-in attributes
        title: 'Card Banner',
        description: 'Custom Card Banner',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            }, 
            subtitle: {
                type: 'string',
                default: ''
            },
            title: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            viewMore: {
                type: 'string',
                default: 'Pogledajte ponudu'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                image,
                alt,
                subtitle,
                title,
                description,
                viewMore
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onSelectImage (image) {
                setAttributes({image: image.sizes.full.url});
            }

            function onAltChange(alt) {
                setAttributes({alt: alt});
            }

            function onSubtitleChange(subtitle) {
                setAttributes({subtitle: subtitle});
            }
            
            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            function onViewMoreChange(viewMore) {
                setAttributes({viewMore: viewMore});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                        <br />
                        <p><strong>Alt image:</strong></p>
                        <TextControl value={ alt } onChange={ onAltChange }></TextControl>
                        <br />
                        <p><strong>Enter url: (ex: /putovanja)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                        <br />
                        <p><strong>Subtitle</strong></p>
                        <TextControl value={ subtitle } onChange={ onSubtitleChange }></TextControl>
                        <br />
                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <br />
                        <p><strong>Description</strong></p>
                        <TextareaControl value={ description } onChange={ onDescriptionChange }></TextareaControl>
                        <br />
                        <p><strong>Link</strong></p>
                        <TextControl value={ viewMore } onChange={ onViewMoreChange }></TextControl>

                    </PanelBody>
                </InspectorControls>
                ,
                <div class="card card-banner">
                    
                    <div class="card-body">
                        <RichText 
                            key="editable" 
                            tagName="div"
                            className="description"
                            placeholder="DESCRIPTION" 
                            value={ description }
                            onChange={ onDescriptionChange } />
                        <div class="title-container">
                            <RichText 
                                key="editable" 
                                tagName="h4"
                                className="title"
                                placeholder="TITLE" 
                                value={ title }
                                onChange={ onTitleChange } />
                                <RichText 
                                key="editable" 
                                tagName="h4"
                                className="subtitle"
                                placeholder="SUBTITLE" 
                                value={ title }
                                onChange={ onSubtitleChange } />
                        </div>
                        <div class="cta">
                            <RichText 
                                key="editable" 
                                tagName="div"
                                className="cta-content"
                                placeholder="Pogledajte ponudu" 
                                value={ viewMore }
                                onChange={ onViewMoreChange } />
                        </div>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                image,
                alt,
                subtitle,
                title,
                description,
                viewMore
            } = attributes;

            const { RawHTML } = window.wp.element;
            return (
                
                <a href={ link } className={ "card card-banner no-hover-decoration" }>
                    <div class="card-image lozad cover-image"  data-background-image={ image } alt={ alt }>
                        <div className="p-4 text-info">
                            <div className="text-horizontal-line mb-1 h2 ">
                                { subtitle }
                            </div>
                            <h4 className="title display-6 fw-normal">
                                { title }
                            </h4>
                            <div className="description">
                                <RawHTML>
                                    { description }
                                </RawHTML>
                            </div>
                            <div className="cta mt-2">
                                <div className="cta-content btn btn-warning text-decoration-none">{ viewMore } <i className="las la-arrow-right"></i></div>
                            </div>
                        </div>
                    </div>
                </a>
                        
            );
        },
    });
}